import { useEffect } from "react";

const DEFAULT_TITLE = "LytePress — Save More, Waste Less, Support Local";
const DEFAULT_DESC = "LytePress — Save More, Waste Less, Support Local. Discover local deals and near-expiry savings across Trinidad & Tobago.";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    const [, key, val] = selector.match(/\[(.+?)="(.+?)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

// Per-page title, description, canonical and social card. Crawlers render our JS, so this
// gives every deal / shop / category page its own snippet instead of the generic one.
export const useSeo = ({ title, description, image, noindex, canonical } = {}) => {
  useEffect(() => {
    const full = title ? `${title} · LytePress` : DEFAULT_TITLE;
    const desc = (description || DEFAULT_DESC).slice(0, 300);
    document.title = full;
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", full);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[name="twitter:title"]', "content", full);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('link[rel="canonical"]', "href", window.location.origin + (canonical || window.location.pathname));
    if (image) {
      setMeta('meta[property="og:image"]', "content", image.startsWith("http") ? image : window.location.origin + image);
    }
    setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow");
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="robots"]', "content", "index, follow");
    };
  }, [title, description, image, noindex, canonical]);
};
